/* GemKrishna 3D Rudraksha viewer. Markup: snippets/gk-rudraksha-3d.liquid.
   Progressive enhancement: the poster image is the default; <model-viewer> replaces it only
   after the model has actually loaded. Nothing here is needed to read the page or to buy. */
(function () {
  'use strict';
  if (window.gkRudraksha3d) return;
  window.gkRudraksha3d = true;

  var MV_SRC = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
  var mvPromise = null;

  function hasWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }

  function loadModelViewer() {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (mvPromise) return mvPromise;
    mvPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = MV_SRC;
      s.onload = function () { customElements.whenDefined('model-viewer').then(resolve, reject); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return mvPromise;
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }

  function mount(box) {
    if (box.dataset.gk3dState) return;
    box.dataset.gk3dState = 'loading';
    var loadBtn = box.querySelector('[data-gk3d-load]');
    if (loadBtn) loadBtn.hidden = true;

    loadModelViewer().then(function () {
      var mv = document.createElement('model-viewer');
      mv.setAttribute('src', box.dataset.src);
      mv.setAttribute('alt', box.dataset.label || '3D Rudraksha');
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('disable-zoom', '');
      mv.setAttribute('disable-pan', '');
      mv.setAttribute('disable-tap', '');
      mv.setAttribute('touch-action', 'pan-y');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('loading', 'eager');
      mv.setAttribute('reveal', 'auto');
      mv.setAttribute('tone-mapping', 'neutral');
      mv.setAttribute('shadow-intensity', '0');
      mv.setAttribute('camera-orbit', '-18deg 78deg 128%');
      mv.setAttribute('min-camera-orbit', 'auto 62deg auto');
      mv.setAttribute('max-camera-orbit', 'auto 102deg 160%');
      mv.setAttribute('field-of-view', '30deg');
      mv.setAttribute('interpolation-decay', '120');
      if (!reducedMotion()) {
        mv.setAttribute('auto-rotate', '');
        mv.setAttribute('auto-rotate-delay', '2500');
        mv.setAttribute('rotation-per-second', '14deg');
      }
      mv.addEventListener('load', function () {
        box.classList.add('is-ready');
        box.dataset.gk3dState = 'ready';
        var hint = box.querySelector('[data-gk3d-hint]');
        if (hint) hint.hidden = false;
      }, { once: true });
      mv.addEventListener('error', function () { fail(box, mv); }, { once: true });
      mv.addEventListener('camera-change', function (e) {
        if (e.detail && e.detail.source === 'user-interaction') box.classList.add('has-interacted');
      });
      // model-viewer's default pan-target dot sits at the exact centre and swallows drags that
      // start there; pan is disabled, so replace it with an inert element.
      var panTarget = document.createElement('span');
      panTarget.slot = 'pan-target';
      panTarget.style.cssText = 'display:none;pointer-events:none';
      mv.appendChild(panTarget);
      box.appendChild(mv);
    }).catch(function () { fail(box); });
  }

  function fail(box, mv) {
    if (mv && mv.parentNode) mv.parentNode.removeChild(mv);
    box.classList.remove('is-ready');
    box.dataset.gk3dState = 'failed';
  }

  function init() {
    var boxes = document.querySelectorAll('[data-gk3d]');
    if (!boxes.length || !hasWebGL()) return;
    var manual = saveData();
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); mount(en.target); }
      });
    }, { rootMargin: '250px 0px' }) : null;

    Array.prototype.forEach.call(boxes, function (box) {
      var btn = box.querySelector('[data-gk3d-load]');
      if (manual || !io) {
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () { mount(box); });
        }
        return;
      }
      io.observe(box);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
